module.exports = "/_next/static/images/omotesando_3_burger-848a9435b63665c5d90c6dfd81e0e662.jpg";